import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { APIRoutes } from "../../../../utils/constants";
import { UserContext } from "../..";
import { toast } from "react-toastify";
import TeamWithPlayer from "./TeamWithPlayers";
import HttpService from "../../../../hooks/Https-services";

const ChannelCards = () => {
  const [playerData, setPlayerData] = useState([]);
  const { selectedTeam, setSelectedPlayer, selectedPlayer }: any =
    useContext(UserContext);
  const [isSkeleton, setIsSkeleton] = useState(true);
  /*
   * Cancelled on unmount, and on a team change that supersedes it.
   *
   * The request used to outlive the component: nothing stopped it, so a reply
   * landing after the reader navigated away still called setState. React then
   * schedules an update against an environment that is gone, which under
   * vitest is a torn-down jsdom and a "window is not defined" rejection nobody
   * catches. It also fixes the out-of-order case, which this is prone to
   * because the query is a join of every selected team: picking teams quickly
   * meant whichever reply landed LAST won, not whichever selection was made
   * last.
   *
   * Same shape as UserEmailHistory and UserListTable.
   */
  useEffect(() => {
    let active = true;

    if (!selectedTeam?.length) {
      setIsSkeleton(false);
      setPlayerData([]);
      setSelectedPlayer([]);
      return;
    }

    (async () => {
      try {
        const req = await HttpService.getS(
          `${APIRoutes.GetAllPlayersHTP}?team_ids=${selectedTeam.join(
            ","
          )}&limit=10`
        );
        if (!active) return;
        if (req) {
          const data = req?.data?.data;
          setPlayerData(data);
          const findDuplicatePlayer = data.map((el: any) =>
            el?.players?.filter((ele: any) =>
              selectedPlayer
                ?.includes(ele.player_id)
                ?.map((ele: any) => ele.player_id)
            )
          );
          const submitArray = [].concat(...findDuplicatePlayer);
          setSelectedPlayer(submitArray);
        }
      } catch (error) {
        // Same as before: the cards simply stay as they are.
      } finally {
        if (active) setIsSkeleton(false);
      }
    })();

    return () => {
      active = false;
    };
    // selectedPlayer is read inside but deliberately not a dependency: it is
    // also SET here, so listing it would re-fire this request on its own
    // result. That was true of the useCallback this replaces too.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTeam]);

  return (
    <>
      {isSkeleton ? (
        <Box
          sx={{ display: "flex", justifyContent: "center", py: 10, width: 1 }}
        >
          <CircularProgress
            size={48}
            sx={{
              color: "#bf311a",
            }}
          />
        </Box>
      ) : (
        <>
          {playerData?.length == 0 ? (
            <Typography sx={{ my: 2 }}>Please Select Team</Typography>
          ) : (
            playerData.map((player: any) => <TeamWithPlayer player={player} />)
          )}
        </>
      )}
    </>
  );
};

export default ChannelCards;
